import { IBreadCrumbItemProps } from '@bimser/components';
import { createSyncAction } from '@bimser/core';
import * as ActionTypesMain from './actionTypes';
import { BreadCrumbItemFactoryFromJS } from '../entities/BreadCrumbFactory';

export default function clickBreadCrumbItemRemoveAnimationCssAction(data: IBreadCrumbItemProps) {
	const payload = BreadCrumbItemFactoryFromJS(data);

	const action = createSyncAction(
		ActionTypesMain.CLICK_BREADCRUMB_ITEM_REMOVE_ANIMATION_CSS,
		payload
	);

	return action;
}
